import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  AddMfaBackup,
  CancelAuthentication,
  ContinueAuthentication,
  DeviceType,
  FlyDeltaPoll,
  InitiateAuthentication,
  InitiateSsoSession,
  InitiateUserRegistration,
  LoginOAuthParams,
  SubmitEmailOtp,
  SubmitSmsNumber,
  SubmitUserRegistration,
  SwapAuthForAccessTokens,
  UserRegistrationInfo
} from '../../../models';
import { NewUserMfaWrapperHelperService } from './new-user-mfa-wrapper-helper.service';

@Injectable({
  providedIn: 'root'
})
export class NewUserMfaWrapperService extends NewUserMfaWrapperHelperService {
  newUserMfaFlow(
    loginOAuthParams: LoginOAuthParams,
    deviceType?: DeviceType,
    verifyEmailMfa = false, //TODO: need to follow up with EAM, current flow not currently use
    password?: string,
    fieldValues?: UserRegistrationInfo,
    otp?: string,
    phoneNumber?: string
  ): Observable<
    | InitiateSsoSession
    | InitiateUserRegistration
    | SubmitUserRegistration
    | InitiateAuthentication
    | SubmitEmailOtp
    | ContinueAuthentication
    | AddMfaBackup
    | SubmitSmsNumber
    | CancelAuthentication
    | FlyDeltaPoll
    | SwapAuthForAccessTokens
    | string
  > {
    let fn;

    const options = {
      REGISTER: () => {
        return this.registerHandler(
          loginOAuthParams,
          verifyEmailMfa,
          password,
          fieldValues
        );
      },
      Email: () => {
        return this.emailHandler(loginOAuthParams, verifyEmailMfa, otp);
      },
      SMS: () => {
        return this.smsMethod.initSMS(
          loginOAuthParams,
          this.flowId,
          otp,
          phoneNumber
        );
      },
      MOBILE: () => {
        return this.flyDeltaMethod.initFlyDelta(
          loginOAuthParams,
          this.flowId,
          this.applicationName,
          this.applicationId
        );
      },
      DEFAULT: () => {
        const swapResponse = this.finish(loginOAuthParams);
        return swapResponse;
      }
    };

    deviceType ? (fn = options[deviceType]) : (fn = options['DEFAULT']);

    return fn();
  }

  registerHandler(
    loginOAuthParams: LoginOAuthParams,
    verifyEmailMfa: boolean,
    password?: string,
    fieldValues?: UserRegistrationInfo
  ): Observable<string | SubmitUserRegistration | InitiateUserRegistration> {
    if (password && fieldValues) {
      return this.registerAccount(loginOAuthParams, password, fieldValues);
    } else {
      return this.initiateUserRegistrationMfaWithEmail(
        loginOAuthParams,
        verifyEmailMfa
      );
    }
  }

  emailHandler(
    loginOAuthParams: LoginOAuthParams,
    verifyEmailMfa: boolean,
    otp?: string
  ): Observable<string | InitiateAuthentication | AddMfaBackup> {
    if (verifyEmailMfa) {
      if (!otp) {
        return this.initiateMfaWithEmailValidation(loginOAuthParams);
      } else if (otp) {
        return this.verifyMfaEmail(loginOAuthParams, this.flowId, otp);
      }
    } else {
      return this.initiateMfaWithoutEmailValidation(
        loginOAuthParams,
        this.flowId
      );
    }
    return of();
  }
}
